<div class="px-2">
    <div class="py-2 pl-1 bg-light section-heading">{{selectedSectionDetail.name}}</div>

    <div class="" id="accordion">
        <div class="mt-3 mb-1" *ngFor="let faq of faqs; let i = index">
            <div class="card">
                <div class="card-header collapsed pointer font13-600" data-toggle="collapse"
                    [attr.data-target]="'#faq-' + i" aria-expanded="false" aria-controls="'faq-' + i">
                    <span>{{faq.question}}</span>
                </div>
                <div class="card-body" [attr.id]="'faq-' + i" class="collapse" data-parent="#accordion">
                    <div class="font12-400" style="padding: 0.75rem 1.25rem;">
                        <ng-container *ngFor="let answerDetails of faq.answer; let k = index">
                            <ng-container [ngTemplateOutlet]="formatAnswerTemplate"
                                [ngTemplateOutletContext]="{ $implicit: answerDetails}">
                            </ng-container>
                        </ng-container>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<ng-template #formatAnswerTemplate let-data>
    <span *ngIf="isArray(data)">
        <ol style="margin-top: 0; margin-bottom: 0;">
            <span *ngFor="let object of data; let i = index">
                <span *ngIf="!isArray(object)">
                    <li style="white-space: pre-wrap">{{ object }}</li>
                </span>
                <span *ngIf="isArray(object)">
                    <ng-container [ngTemplateOutlet]="formatAnswerTemplate"
                        [ngTemplateOutletContext]="{ $implicit: object}">
                    </ng-container>
                </span>
            </span>
        </ol>
    </span>
    <span *ngIf="!isArray(data)">
        <div style="white-space: pre-wrap">
            <span>{{ data }}</span>
        </div>
    </span>
</ng-template>